module.exports = __webpack_public_path__ + "img/patent_image14.54aa7d93.png";